/* eslint-disable no-undef,react/no-string-refs,react/forbid-prop-types,react/no-unused-prop-types,no-underscore-dangle,jsx-a11y/label-has-for */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import L from 'leaflet';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';

import { getLocationText } from '../../utils/geo';
import {
  lockDoorsClick,
  ignitionClick,
  serviceModeClick,
  trunkClick,
  setAutorunEngineDelayClick,
  setWebasto,
} from './actions';
import { SidebarFooter } from './SidebarFooter/index';
import { MapTooltip } from '../DeviceControl/Tooltip';
import { LockDoors } from '../DeviceControl/LockDoors';
import { DeviceMap } from './DeviceMap';
import {
  clearTooltip,
  holdDown,
  lockDoorsResult,
  resetDeviceLockDoors,
  resetDeviceToggleIgnition,
  resetDeviceUnlockTrunk,
  setTooltip,
  toggleIgnitionResult,
  unlockTrunkResult,
} from '../../sagas/devices/actions';
import { IgnitionButton } from '../DeviceControl/Ignition/index';
import { WebastoButton } from '../DeviceControl/Webasto/index';

const TARGET_VOLTAGES = [
  10500,
  11310,
  11580,
  11750,
  11900,
  12060,
  12200,
  12320,
  12420,
  12500,
  12600,
];

const voltageToPercents = voltage => {
  if (voltage >= TARGET_VOLTAGES[10]) return 100;
  if (voltage <= TARGET_VOLTAGES[0]) return 0;

  for (let i = 1; i <= 10; i += 1) {
    if (voltage <= TARGET_VOLTAGES[i]) {
      const previousVoltage = TARGET_VOLTAGES[i - 1];
      return Math.round(
        (i -
          1 +
          (voltage - previousVoltage) /
            (TARGET_VOLTAGES[i] - previousVoltage)) *
          10,
      );
    }
  }
};

@translate(['common', 'dashboard-sidebar', 'dashboard'], { wait: true })
class DashboardSidebar extends Component {
  constructor(props) {
    super(props);

    this.animationInterval = null;
    this.state = {
      mapFullscreen: false,
      animating: false,
      autorunMenuOpened: false,
      deviceInfoExpanded: false
    };
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { tooltip } = nextProps;

    this.checkIfDoorsStateChanged(nextProps);
    this.checkIfIgnitionStateChanged(nextProps);
    this.checkIfTrunkStateChanged(nextProps);

    if (
      this.props.tooltip !== tooltip &&
      this.props.currentDeviceStats.deviceId ===
        nextProps.currentDeviceStats.deviceId
    ) {
      this.setState({
        showTooltip: tooltip !== null || false,
        tooltip:
          tooltip !== null
            ? {
                type: 'start-note',
                text: tooltip.type,
                on: tooltip.on,
              }
            : {},
      });
    }
    this.setState({ isServiceOn: nextProps.currentDeviceStats.serviceOn });
  }
  componentDidUpdate() {
    const { mapContainer } = this.refs;
    const map = mapContainer.refs.map;
    this.icon = mapContainer.refs.icon;

    const position = this.props.currentDeviceStats.lat
      ? [
          this.props.currentDeviceStats.lat / 10000000,
          this.props.currentDeviceStats.lon / 10000000,
        ]
      : [0, 0];
    if (this.state.mapFullscreen) {
      document.body.classList.add('mapOpen');
      document.body.style.overflow = 'hidden';
      map.leafletElement.dragging.enable();
      map.leafletElement.scrollWheelZoom.enable();
      map.leafletElement.boxZoom.enable();
    } else {
      document.body.classList.remove('mapOpen');
      document.body.style.overflow = 'auto';
      map.leafletElement.dragging.disable();
      map.leafletElement.scrollWheelZoom.disable();
    }
    map.leafletElement.invalidateSize();
    map.leafletElement.panTo(position);
  }
  get canLockTrunk() {
    return (
      this.props.currentDevice.canLockTrunk &&
      this.props.currentDevice.canManage
    );
  }
  get canAutorun() {
    return (
      this.props.currentDevice.canAutorun && this.props.currentDevice.canManage
    );
  }
  get canLockDoors() {
    return (
      this.props.currentDevice.canLockDoors &&
      this.props.currentDevice.canManage
    );
  }
  checkIfDoorsStateChanged = nextProps => {
    const { currentDeviceStats } = this.props;
    const currentDeviceId = currentDeviceStats.deviceId;
    const nextDeviceId = nextProps.currentDeviceStats.deviceId;

    if (
      nextProps.lockDoorsState[currentDeviceId] &&
      nextProps.lockDoorsState[nextDeviceId] > 0
    ) {
      if (
        currentDeviceStats &&
        currentDeviceStats.centralLockOn !==
          nextProps.currentDeviceStats.centralLockOn
      ) {
        this.props.resetLockDoors({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.lockDoorsState[nextDeviceId])) {
          this.props.lockDoorsResult({
            result: true,
            on: nextProps.currentDeviceStats.centralLockOn,
          });
        }
      } else if (
        nextProps.lockDoorsState[currentDeviceId] > 0 &&
        Date.now() - nextProps.lockDoorsState[nextDeviceId] >= 3 * 60 * 1000
      ) {
        this.props.resetLockDoors({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.lockDoorsState[nextDeviceId])) {
          this.props.lockDoorsResult({
            result: false,
            on: nextProps.currentDeviceStats.centralLockOn,
          });
        }
      }
    }
  };
  checkIfIgnitionStateChanged = nextProps => {
    const { currentDeviceStats } = this.props;
    const currentDeviceId = currentDeviceStats.deviceId;
    const nextDeviceId = nextProps.currentDeviceStats.deviceId;

    if (
      nextProps.ignitionState[currentDeviceId] &&
      nextProps.ignitionState[nextDeviceId] > 0
    ) {
      if (
        currentDeviceStats &&
        currentDeviceStats.ignitionOn !==
          nextProps.currentDeviceStats.ignitionOn
      ) {
        this.props.resetIgnition({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.ignitionState[nextDeviceId])) {
          this.props.toggleIgnitionResult({
            result: true,
            on: nextProps.currentDeviceStats.ignitionOn,
          });
        }
      } else if (
        nextProps.ignitionState[currentDeviceId] > 0 &&
        Date.now() - nextProps.ignitionState[nextDeviceId] >= 0.5 * 60 * 1000
      ) {
        this.props.resetIgnition({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.ignitionState[nextDeviceId])) {
          this.props.toggleIgnitionResult({
            result: false,
            on: !nextProps.currentDeviceStats.ignitionOn,
          });
        }
      }
    }
  };

  checkIfTrunkStateChanged = nextProps => {
    const { currentDeviceStats } = this.props;
    const currentDeviceId = currentDeviceStats.deviceId;
    const nextDeviceId = nextProps.currentDeviceStats.deviceId;

    if (
      nextProps.unlockTrunkState[currentDeviceId] &&
      nextProps.unlockTrunkState[nextDeviceId] > 0
    ) {
      if (
        currentDeviceStats &&
        currentDeviceStats.unlockTrunk !==
          nextProps.currentDeviceStats.unlockTrunk
      ) {
        this.props.resetUnlockTrunkState({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.unlockTrunkState[nextDeviceId])) {
          this.props.unlockTrunkResult({
            result: true,
            on: !nextProps.currentDeviceStats.unlockTrunk,
          });
        }
      } else if (
        nextProps.unlockTrunkState[currentDeviceId] > 0 &&
        Date.now() - nextProps.unlockTrunkState[nextDeviceId] >= 3 * 60 * 1000
      ) {
        this.props.resetUnlockTrunkState({ deviceId: nextDeviceId });

        if (this.isRecentAction(nextProps.unlockTrunkState[nextDeviceId])) {
          this.props.unlockTrunkResult({
            result: false,
            on: !nextProps.currentDeviceStats.unlockTrunk,
          });
        }
      }
    }
  };
  isRecentAction = date => {
    const currentDate = Date.now();
    return currentDate - date <= 60 * 4 * 1000;
  };

  openCloseTrunkClickHandler = e => {
    e.preventDefault();
    this.setState({ animating: false });
    this.icon.leafletElement._icon
      .querySelector('.car-circle')
      .classList.remove('start');
  };
  openCloseTrunkMouseDownHandler = e => {
    e.preventDefault();
    setTimeout(() => {
      this.icon.leafletElement._icon
        .querySelector('.car-circle')
        .classList.add('start');
    }, 0);
    this.progress = 0;
    const self = this;
    // eslint-disable-next-line no-undef
    this.animationInterval = window.setInterval(() => {
      self.progress += 1;
      if (self.progress > 99) {
        self.progress = -1;
        clearInterval(self.animationInterval);
        self.props.toggleTrunk({
          deviceId: self.props.currentDevice.id,
          on: self.props.currentDeviceStats.unlockTrunk,
        });
        self.setState({ animating: false });
      }
    }, 3000 / 100);
    this.setState({ animating: true });

    this.showHoldTooltip();
  };
  openCloseTrunkMouseUpHandler = e => {
    e.preventDefault();
    clearInterval(this.animationInterval);
    this.hideHoldTooltip();
    this.icon.leafletElement._icon
      .querySelector('.car-circle')
      .classList.remove('start');
    this.setState({ animating: false });
  };

  serviceModeChangeHandler = () => {
    this.setState({ isServiceMode: !this.props.currentDeviceStats.serviceOn });
    this.props.toggleServiceMode({
      deviceId: this.props.currentDevice.id,
      on: !this.props.currentDeviceStats.serviceOn,
    });
  };

  showHoldTooltip = () => {
    const { setTooltipAction } = this.props;
    setTooltipAction({
      type: holdDown,
    });
  };
  hideHoldTooltip = () => {
    if (this.progress <= 99 && this.progress !== -1) {
      this.hideTooltip(0);
      this.progress = 0;
    }
  };
  hideTooltip = delay => {
    setTimeout(() => {
      this.props.clearTooltip();
    }, delay);
  };

  handleAnimationState = state => {
    this.setState(
      {
        animating: state,
      },
      () => {
        if (state) {
          this.icon.leafletElement._icon
            .querySelector('.car-circle')
            .classList.add('start');
          this.icon.leafletElement._icon
            .querySelector('.car')
            .classList.add('active');
        } else {
          this.icon.leafletElement._icon
            .querySelector('.car-circle')
            .classList.remove('start');
          this.icon.leafletElement._icon
            .querySelector('.car')
            .classList.remove('active');
        }
      },
    );
  };
  toggleFullscreen(e) {
    e.preventDefault();

    this.setState({
      mapFullscreen: !this.state.mapFullscreen,
    });
  }
  renderSecurityNote() {
    const { t } = this.props;
    if (this.props.currentDeviceStats.serviceOn) {
      return (
        <div className="car-note service-note">
          <span>{t('dashboard-sidebar:serviceMode')}</span>
        </div>
      );
    } else if (this.props.currentDeviceStats.guardOn) {
      return (
        <div className="car-note security-note">
          <span>{t('dashboard-sidebar:guardMode')}</span>
        </div>
      );
    }
    return '';
  }
  renderDevicesStats() {
    const { t } = this.props;
    const voltage = voltageToPercents(this.props.currentDeviceStats.voltage);

    return (
      <div>
        {this.props.currentDevice.provideFuelLevel ? (
          <div className="info__set__row">
            <div className="holder">
              <div className="title">{t('dashboard-sidebar:fuel')}</div>
              <div className="info">
                {Math.floor(
                  this.props.currentDevice.fuelTankCapacity *
                    (this.props.currentDeviceStats.fuelLevel / 100),
                )}
                {t('dashboard:l')}
              </div>
            </div>
            <div
              className="info__set__progress"
              data-progress={this.props.currentDeviceStats.fuelLevel}
            >
              <span />
            </div>
          </div>
        ) : null}
        <div className="info__set__row ">
          <div className="holder">
            <div className="title">{t('dashboard-sidebar:battery')}</div>
            <div className="info">
              <div className="battery" data-progress={voltage}>
                <span />
              </div>
              {voltage}%
            </div>
          </div>
        </div>
        {this.props.currentDevice.temperatureUnitId !== null && (
          <div className="info__set__row ">
            <div className="holder">
              <div className="title">{t('dashboard-sidebar:temperature')}</div>
              <div className="info">
                {this.props.currentDeviceStats.temperature}° C
              </div>
            </div>
          </div>
        )}
        {this.props.currentDevice.canCANOdometer ? (
          <div className="info__set__row">
            <div className="holder">
              <div className="title">{t('dashboard-sidebar:mileage')}</div>
              <div className="info">
                {Math.round(
                  this.props.currentDeviceStats.canOdometer / 1000,
                ).toLocaleString('ru')}
                {t('dashboard:km')}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  toggleDeviceInfo = () => {
    this.setState({
      deviceInfoExpanded: !this.state.deviceInfoExpanded
    })
  }
  render() {
    const { t } = this.props;
    const { tooltip } = this.state;
    const classNames = this.state.animating
      ? 'start-mode'
      : cx({
          'online-mode': this.props.currentDeviceStats.powerOn,
          'service-mode':
            this.props.currentDeviceStats.serviceOn || this.state.isServiceMode,
          'security-mode': this.props.currentDeviceStats.guardOn,
        });

    const mapClassNames = cx('aside__map', {
      zoomMap: this.state.mapFullscreen,
    });

    const position = this.props.currentDeviceStats.lat
      ? [
          this.props.currentDeviceStats.lat / 10000000,
          this.props.currentDeviceStats.lon / 10000000,
        ]
      : [0, 0];
    const icon = L.divIcon({
      html: `<div class="car-map">
              <i class="car">
                <span class="bubbles-list">
                  <i></i><i></i><i></i></i><i></i><i>
                  <i></i><i></i><i></i><i></i><i></i><i>
                  </i><i></i><i></i><i></i><i></i><i></i>
                </span>
              </i>
              <span class="car-circle active"><span><em></em></span><span><em></em></span></span>
              <div class="car-note online-note"><span>${t(
                'dashboard-sidebar:locked',
              )}</span></div>
              <div class="map-point-tooltip">
                <span>${this.props.currentDeviceStats.geoData &&
                  getLocationText(this.props.currentDeviceStats.geoData)}</span>
                <p>${t('dashboard-sidebar:updatedAt')} ${moment(
        this.props.currentDeviceStats.occurrenceTime * 1000,
      ).format('HH:mm, DD.MM.YYYY')}</p>
              </div>
            </div>`,
    });
    const tileUrl = L.Browser.retina
      ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
      : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';
    let controlsNumber = 0;
    if (
      this.props.currentDevice.canLockDoors &&
      this.props.currentDevice.canManage
    )
      controlsNumber++;
    if (
      this.props.currentDevice.canAutorun &&
      this.props.currentDevice.canManage
    )
      controlsNumber++;
    if (
      this.props.currentDevice.canLockTrunk &&
      this.props.currentDevice.canManage
    )
      controlsNumber++;
    if (
      this.props.currentDevice.canWebasto &&
      this.props.currentDevice.canManage
    )
      controlsNumber++;

    const trunkContainerCss = cx('control-panel__button', {
      'control-panel__button_shape_quadratic': controlsNumber === 3,
    });
    const trunkBtnClass = cx('control-button', 'control-button_type_trunk', {
      'control-button_state_active': this.props.currentDeviceStats.unlockTrunk,
      'control-button_shape_quadratic': controlsNumber === 3,
    });

    return (
      <aside className="aside">
        <div className="aside-scroll">
          <div className={classNames}>
            <div className={mapClassNames}>
              <div className="map-wrap">
                <DeviceMap
                  ref="mapContainer"
                  position={position}
                  mapFullscreen={this.state.mapFullscreen}
                  tileUrl={tileUrl}
                  icon={icon}
                />
                <span
                  role="presentation"
                  onClick={this.toggleFullscreen}
                  className={`btn-${
                    this.state.mapFullscreen ? 'close' : 'zoom'
                  }-map`}
                />
                <div className={`deviceInfo ${this.state.deviceInfoExpanded ? 'expanded' : ''}`} onClick={this.toggleDeviceInfo}>
                  <a href="javascript:;" className="deviceInfo__overlay" onClick={this.toggleDeviceInfo}></a>
                  <div className="actions">
                      {this.canLockDoors && (
                        <div className={`action lockdoors ${this.props.currentDeviceStats.centralLockOn ? 'disabled' : ''}`}>
                          {t(`dashboard-sidebar:infoCentralLock${this.props.currentDeviceStats.centralLockOn ? 'Off' : 'On'}`)}
                        </div>
                      )}
                      {this.canAutorun && (
                        <div className={`action ignition ${this.props.currentDeviceStats.ignitionOn ? '' : 'disabled'}`}>
                          {t(`dashboard-sidebar:infoIgnition${this.props.currentDeviceStats.ignitionOn ? 'On' : 'Off'}`)}
                        </div>
                      )}
                      {this.canWebasto && (
                        <div className={`action webasto ${this.props.currentDeviceStats.webastoOn ? '' : 'disabled'}`}>
                          {t(`dashboard-sidebar:infoWebasto${this.props.currentDeviceStats.webastoOn ? 'On' : 'Off'}`)}
                        </div>
                      )}
                      {this.props.currentDevice.canServiceMode && this.props.currentDeviceStats.serviceOn && (
                        <div className={`action service`}>
                          {t(`dashboard-sidebar:infoService`)}
                        </div>
                      )}
                      {this.props.currentDevice.canGuardMode && this.props.currentDeviceStats.guardOn && (
                        <div className={`action guard`}>
                          {t(`dashboard-sidebar:infoGuard`)}
                        </div>
                      )}

                      {!this.props.currentDeviceStats.guardOn && !this.props.currentDeviceStats.serviceOn && (
                        <div className={`action no_mode`}>
                          {t(`dashboard-sidebar:infoNoMode`)}
                        </div>
                      )}

                      <div className={`action connection-level level${this.props.connectionLevels[this.props.currentDevice.id] || 1}`}>
                      {t(`dashboard-sidebar:infoConnectionLevel${this.props.connectionLevels[this.props.currentDevice.id] || 1}`)}
                      </div>
                  </div>
                </div>
                {this.props.tooltip &&
                  this.state.showTooltip && (
                    <MapTooltip
                      type={tooltip.type}
                      text={t(
                        `dashboard-sidebar:${
                          tooltip.on ? `${tooltip.text}_ON` : tooltip.text
                        }`,
                      )}
                    />
                  )}
              </div>
            </div>
            {this.props.currentDevice.id ? (
              <div className="control-panel">
                {controlsNumber <= 3 && (
                  <div className="control-panel__actions">
                    {this.canLockDoors && (
                      <LockDoors
                        quadratic={controlsNumber === 3}
                        handleAnimationState={this.handleAnimationState}
                      />
                    )}
                    {this.canAutorun && (
                      <IgnitionButton
                        quadratic={controlsNumber === 3}
                        handleAnimationState={this.handleAnimationState}
                      />
                    )}
                    {this.canLockTrunk &&
                      controlsNumber <= 3 && (
                        <div className={trunkContainerCss}>
                          <button
                            type="button"
                            disabled={this.isRecentAction(
                              this.props.trunkLocked,
                            )}
                            onClick={this.openCloseTrunkClickHandler}
                            onMouseDown={this.openCloseTrunkMouseDownHandler}
                            onMouseUp={this.openCloseTrunkMouseUpHandler}
                            className={trunkBtnClass}
                          >
                            <span className="control-button__icon" />
                            <span className="control-button__text">
                              {this.props.currentDeviceStats.unlockTrunk
                                ? t('dashboard-sidebar:closeTrunk')
                                : t('dashboard-sidebar:openTrunk')}
                            </span>
                          </button>
                        </div>
                      )}
                  </div>
                )}
                {controlsNumber === 4 && (
                  <div className="control-panel__actions">
                    {this.props.currentDevice.canWebasto &&
                      this.props.currentDevice.canManage && (
                        <WebastoButton
                          quadratic={false}
                          handleAnimationState={this.handleAnimationState}
                        />
                      )}
                    {this.props.currentDevice.canAutorun &&
                      this.props.currentDevice.canManage && (
                        <IgnitionButton
                          quadratic={false}
                          handleAnimationState={this.handleAnimationState}
                        />
                      )}
                  </div>
                )}
                {controlsNumber === 4 && (
                  <div className="control-panel__actions">
                    {this.canLockDoors && (
                      <LockDoors
                        quadratic={false}
                        handleAnimationState={this.handleAnimationState}
                      />
                    )}
                    {this.canLockTrunk && (
                      <div className={trunkContainerCss}>
                        <button
                          type="button"
                          disabled={this.isRecentAction(this.props.trunkLocked)}
                          onClick={this.openCloseTrunkClickHandler}
                          onMouseDown={this.openCloseTrunkMouseDownHandler}
                          onMouseUp={this.openCloseTrunkMouseUpHandler}
                          className={trunkBtnClass}
                        >
                          <span className="control-button__icon" />
                          <span className="control-button__text">
                            {this.props.currentDeviceStats.unlockTrunk
                              ? t('dashboard-sidebar:closeTrunk')
                              : t('dashboard-sidebar:openTrunk')}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                )}
                <div className="control-panel__device-info">
                  {this.props.currentDevice.canServiceMode &&
                    this.props.currentDevice.canManage && (
                      <div
                        className="info__set__service"
                        style={{
                          display: this.props.currentDevice.canServiceMode
                            ? 'block'
                            : 'none',
                        }}
                      >
                        <div className="info__set__service__note">
                          <h3>
                            {t('dashboard-sidebar:serviceMode')}{' '}
                            <span className="hint">
                              ?<span>
                                {t('dashboard-sidebar:serviceModeHint')}
                              </span>
                            </span>
                          </h3>
                        </div>
                        <div className="info__set__service__check">
                          <label className="switch">
                            <input
                              disabled={this.props.serviceModeDisabled}
                              type="checkbox"
                              checked={this.props.currentDeviceStats.serviceOn}
                              onChange={this.serviceModeChangeHandler}
                            />
                            <span className="slider" />
                          </label>
                        </div>
                      </div>
                    )}
                  {this.props.currentDeviceStats !== null &&
                    this.renderDevicesStats()}
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <SidebarFooter />
      </aside>
    );
  }
}

DashboardSidebar.WrappedComponent.propTypes = {
  currentDevice: PropTypes.object.isRequired,
  currentDeviceStats: PropTypes.object.isRequired,
  lockDoors: PropTypes.func.isRequired,
  toggleIgnition: PropTypes.func.isRequired,
  toggleServiceMode: PropTypes.func.isRequired,
  toggleWebasto: PropTypes.func.isRequired,
  handleAutorunEngineDelayInSeconds: PropTypes.func.isRequired,
  clearTooltip: PropTypes.func.isRequired,
  ignitionDisabled: PropTypes.bool.isRequired,
  serviceModeDisabled: PropTypes.bool.isRequired,
  lockDoorsState: PropTypes.object.isRequired,
  resetLockDoors: PropTypes.func.isRequired,
  setTooltipAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  resetIgnition: PropTypes.func.isRequired,
  lockDoorsResult: PropTypes.func.isRequired,
  toggleIgnitionResult: PropTypes.func.isRequired,
  tooltip: PropTypes.shape({
    type: PropTypes.string,
  }),
  unlockTrunkResult: PropTypes.func.isRequired,
  resetUnlockTrunkState: PropTypes.func.isRequired,
};
DashboardSidebar.WrappedComponent.defaultProps = {
  tooltip: null,
};
export default connect(
  state => ({
    currentDevice: state.devices.currentDevice,
    currentDeviceStats: state.devices.currentDeviceStats,
    lockDisabled: state.devices.lockDisabled,
    ignitionDisabled: state.devices.ignitionDisabled,
    serviceModeDisabled: state.devices.serviceModeDisabled,
    lockDoorsState: state.devices.lockDoorsState,
    ignitionState: state.devices.ignitionState,
    unlockTrunkState: state.devices.unlockTrunkState,
    trunkLocked:
      state.devices.unlockTrunkState[state.devices.currentDevice.id] || 0,
    tooltip: state.devices.tooltip,
    connectionLevels: state.devices.devicesConnectionLevels,
  }),
  dispatch => ({
    lockDoors({ deviceId, on }) {
      return dispatch(lockDoorsClick({ deviceId, on }));
    },
    toggleIgnition({ deviceId, on }) {
      return dispatch(ignitionClick({ deviceId, on }));
    },
    toggleServiceMode({ deviceId, on }) {
      return dispatch(serviceModeClick({ deviceId, on }));
    },
    toggleTrunk({ deviceId, on }) {
      return dispatch(trunkClick({ deviceId, on }));
    },
    handleAutorunEngineDelayInSeconds({ deviceId, seconds }) {
      return dispatch(setAutorunEngineDelayClick({ deviceId, seconds }));
    },
    toggleWebasto({ deviceId, on }) {
      return dispatch(setWebasto({ deviceId, on }));
    },
    setTooltipAction({ type }) {
      return dispatch(setTooltip({ type }));
    },
    clearTooltip() {
      return dispatch(clearTooltip());
    },
    resetLockDoors({ deviceId }) {
      return dispatch(resetDeviceLockDoors({ deviceId }));
    },
    resetIgnition({ deviceId }) {
      return dispatch(resetDeviceToggleIgnition({ deviceId }));
    },
    lockDoorsResult({ result, on }) {
      return dispatch(lockDoorsResult({ result, on }));
    },
    toggleIgnitionResult({ result, on }) {
      return dispatch(toggleIgnitionResult({ result, on }));
    },
    unlockTrunkResult({ result, on }) {
      return dispatch(unlockTrunkResult({ result, on }));
    },
    resetUnlockTrunkState({ deviceId }) {
      return dispatch(resetDeviceUnlockTrunk({ deviceId }));
    },
  }),
)(DashboardSidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/DashboardSidebar.js